import { FC } from 'react'
import { Modal } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'
import { PrimaryButton } from '../styles/Buttons'

interface Props {
    show: boolean
    onHide: Function
    title: string
    body: string
    size?: any
    closeText?: string
}


const Dialog: FC<Props> = ({ show, onHide, title, body, size, closeText }: Props) => {

    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size={size || 'lg'}
                aria-labelledby="contained-modal-title-vcenter"
                centered={true}
                className={'SimutechModal'}
            >
                <Modal.Header closeButton={false}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {ReactHtmlParser(title)}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {ReactHtmlParser(body)}
                </Modal.Body>
                <Modal.Footer>
                    <PrimaryButton onClick={onHide}>{closeText || 'Close'}</PrimaryButton>
                </Modal.Footer>
            </Modal>
        </>
    )

}

export default Dialog